import React from 'react';
import Yolo from './Yolo'
import './App.css';
import './styles/style.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="App">
      <Yolo/>
      
    </div>
  );
}

export default App;
